import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { setNewViewstate, useViewport } from "../GlobalViewState"
import { memo } from "react"

const MapCompass = memo(({ isLight }: { isLight: boolean }) => {
    const { bearing } = useViewport()

    return (
        <div
            className={classNames(
                "w-9 h-9 flex items-center justify-center rounded-full cursor-pointer pointer-events-auto border",
                {
                    "bg-black-600 hover:bg-gray-700 border-white-300 hover:border-white-400":
                        !isLight,
                    "bg-white-500 hover:bg-gray-0 border-black-300 hover:border-black-400": isLight,
                }
            )}
            onClick={() => setNewViewstate({ bearing: 0 }, { disableFly: true })}
        >
            <Icons.SmallIcon
                Icon={isLight ? Icons.CompassNeedleDark : Icons.CompassNeedleLight}
                style={{ transform: `rotate(${-bearing}deg)` }}
                className={classNames({
                    "text-gray-500": !isLight,
                    "text-gray-0": isLight,
                })}
            />
        </div>
    )
})

MapCompass.displayName = "MapCompass"

export { MapCompass }
